import styled from 'styled-components/macro';
import {lazyProviderInfo} from "../components/WithProvider";

styled;

export const getLanguageInfo = (locale, providerInfo, partial) =>
  providerInfo?.preferredLanguage?.options?.find(o =>
    partial
    ? o.id.includes(locale)
    : o.id == locale
  )

export const getDefaultLanguageInfo = (providerInfo) =>
  providerInfo?.preferredLanguage?.options?.find(o => o.id == (providerInfo?.preferredLanguage?.defaultLanguage || providerInfo?.preferredLanguage?.default)) ||
  providerInfo?.preferredLanguage?.options[0] || providerInfo?.preferredLanguage?.defaultLanguage && {id: providerInfo?.preferredLanguage?.defaultLanguage}


let enabled = false
let withUrlParam = false
export const I18NInitEnable = () => {
  enabled = true
  return null
}
export const shouldAddLocaleUrlParam = () => withUrlParam
export const getInitLocale = () => {
  const providerInfo = lazyProviderInfo.read()
  if (providerInfo.preferredLanguage?.options?.length < 2 || !enabled) {
    const defaultLanguage = getDefaultLanguageInfo(providerInfo)
    return defaultLanguage?.id || "en-US"
  }
  withUrlParam = true
  // const providerInfo =  {}
  const params = new URLSearchParams(window.location.search)
  const urlLocale = params.get("locale")
  if (urlLocale) {
    const languageInfo = getLanguageInfo(urlLocale, providerInfo)
    if (languageInfo) {
      return languageInfo.id
    }
  }
  const storedLocally = localStorage.getItem("last-locale")
  if (storedLocally) {
    const languageInfo = getLanguageInfo(storedLocally, providerInfo)
    if (languageInfo) {
      return languageInfo.id
    }
  }
  const browserLang = getLanguageInfo(navigator.language, providerInfo, true)

  if (browserLang) {
    return browserLang.id
  }
  const defaultLanguage = getDefaultLanguageInfo(providerInfo)
  return defaultLanguage.id
}

export const getLocaleCountry = (locale) => (locale || "en-FR").split("-")?.[1] || "US"